// axios
import axios from 'axios'
import Vue from 'vue'
import { i18n } from './i18n'


const httpClient = axios.create({
  // You can add your headers here
  // ================================
  baseURL: process.env.VUE_APP_API_BASEURL || 'http://localhost:8000/api/'
  // timeout: 1000,
  // headers: {'X-Custom-Header': 'foobar'}
})

httpClient.interceptors.request.use(
  config => {

    config.headers["Accept-Language"] = i18n.locale;

    const accessToken = localStorage.getItem('token')
    if (accessToken) config.headers.Authorization = `token ${accessToken}`

    return config
  },
  error => Promise.reject(error),
)

httpClient.interceptors.response.use(function (response) {
  return {
    ok: true,
    status: response.status,
    data: response.data,
  };
}, function (error) {

  if (!error.response) {
    alert("Yhteysvirhe");
  }
  else if (error.response.status == 401) {
    window.localStorage.clear();
    window.location.href = '/login';
  }
  else {
    let errorMessage = error.response.data;
    if (error.response.status == 400) {
      errorMessage = JSON.stringify(error.response.data);
    }
    else if (error.response.status == 403) {
      errorMessage = "Forbidden";
    }

    return {
      ok: false,
      status: error.response.status,
      error: errorMessage,
      data: error.response.data,
    }
  }
});

Vue.prototype.$http = httpClient

export default httpClient
